(function () {
  'use strict';

  // ─── 1. STAR SPARKLE CURSOR ──────────────────────────────────────────────────
  // 4-point star — clean luxury sparkle, white
  const DIAMOND_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="-12 -12 24 24">
    <polygon points="0,-11 1.1,-1.1 0,11 -1.1,-1.1" fill="white" opacity="0.95"/>
    <polygon points="-8,0 -1.1,1.1 8,0 -1.1,-1.1" fill="white" opacity="0.95"/>
    <polygon points="0,-7 0.65,-0.65 0,7 -0.65,-0.65" fill="white" opacity="0.55" transform="rotate(45)"/>
    <circle cx="0" cy="0" r="1.4" fill="white"/>
    <circle cx="0" cy="-10.5" r="0.55" fill="white" opacity="0.5"/>
  </svg>`;

  const DIAMOND_HOVER_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="-18 -18 36 36">
    <circle cx="0" cy="0" r="14" fill="none" stroke="white" stroke-width="0.7" opacity="0.2"/>
    <polygon points="0,-16 1.6,-1.6 0,16 -1.6,-1.6" fill="white" opacity="0.9"/>
    <polygon points="-12,0 -1.6,1.6 12,0 -1.6,-1.6" fill="white" opacity="0.9"/>
    <polygon points="0,-10 1,-1 0,10 -1,-1" fill="white" opacity="0.45" transform="rotate(45)"/>
    <circle cx="0" cy="0" r="2" fill="white"/>
    <circle cx="0" cy="-15.5" r="0.8" fill="white" opacity="0.5"/>
    <circle cx="15.5" cy="0" r="0.8" fill="white" opacity="0.5"/>
    <circle cx="0" cy="15.5" r="0.8" fill="white" opacity="0.5"/>
    <circle cx="-15.5" cy="0" r="0.8" fill="white" opacity="0.5"/>
  </svg>`;

  function initCursorTrailer() {
    if (window.matchMedia('(hover: none)').matches) return;

    // Hide native cursor globally
    document.documentElement.style.cursor = 'none';

    const cursor = document.createElement('div');
    cursor.className = 'paije-cursor';
    cursor.innerHTML = DIAMOND_SVG;
    document.body.appendChild(cursor);

    // Trail dots
    const TRAIL_COUNT = 5;
    const trail = [];
    for (let i = 0; i < TRAIL_COUNT; i++) {
      const dot = document.createElement('div');
      dot.className = 'paije-cursor-trail';
      dot.style.opacity = (1 - i / TRAIL_COUNT) * 0.35;
      dot.style.width = dot.style.height = `${5 - i * 0.7}px`;
      document.body.appendChild(dot);
      trail.push({ el: dot, x: -100, y: -100 });
    }

    let mx = -100, my = -100, cx = -100, cy = -100;
    const trailPositions = Array(TRAIL_COUNT).fill(null).map(() => ({ x: -100, y: -100 }));
    let isHover = false;

    document.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; });
    document.addEventListener('mouseleave', () => { mx = -200; my = -200; });

    document.addEventListener('mouseover', (e) => {
      if (e.target.closest('a, button, .card-wrapper, input, select')) {
        if (!isHover) {
          isHover = true;
          cursor.innerHTML = DIAMOND_HOVER_SVG;
          cursor.classList.add('paije-cursor--hover');
          document.documentElement.style.cursor = 'none';
        }
      }
    });
    document.addEventListener('mouseout', (e) => {
      if (e.target.closest('a, button, .card-wrapper, input, select')) {
        isHover = false;
        cursor.innerHTML = DIAMOND_SVG;
        cursor.classList.remove('paije-cursor--hover');
      }
    });

    function tick() {
      cx += (mx - cx) * 0.14;
      cy += (my - cy) * 0.14;
      cursor.style.transform = `translate(${cx}px, ${cy}px)`;

      // Trail follows with increasing lag
      trailPositions[0].x += (cx - trailPositions[0].x) * 0.4;
      trailPositions[0].y += (cy - trailPositions[0].y) * 0.4;
      trail[0].el.style.transform = `translate(${trailPositions[0].x}px, ${trailPositions[0].y}px)`;
      for (let i = 1; i < TRAIL_COUNT; i++) {
        trailPositions[i].x += (trailPositions[i-1].x - trailPositions[i].x) * 0.35;
        trailPositions[i].y += (trailPositions[i-1].y - trailPositions[i].y) * 0.35;
        trail[i].el.style.transform = `translate(${trailPositions[i].x}px, ${trailPositions[i].y}px)`;
      }
      requestAnimationFrame(tick);
    }
    tick();
  }

  // ─── 2. SCROLL-TRIGGERED ANIMATIONS ─────────────────────────────────────────
  function initScrollAnimations() {
    // Scoped to main content only — never touches header, nav, or announcement bar
    const SCOPE = 'main, #MainContent, .main-content, [role="main"]';
    const root = document.querySelector(SCOPE) || document.body;

    const SELECTORS = [
      '.card-wrapper',
      '.title-wrapper',
      '.collection-list__item',
      '.collection-hero__text',
      '.editorial-hero__content',
      '.footer__content > *',
      '.product__info-wrapper > *',
      '.page-width > p',
      '.rich-text__wrapper',
      '.image-with-text__content',
      '.featured-collection',
    ];

    const els = [];
    SELECTORS.forEach((sel) => {
      root.querySelectorAll(sel).forEach((el) => {
        // Skip if already has animation or is in header/nav
        if (el.closest('header, nav, .announcement-bar, .header')) return;
        els.push(el);
      });
    });

    if (!els.length) return;

    // Stagger siblings within same grid/row container
    const parentMap = new Map();
    els.forEach((el) => {
      const p = el.parentElement;
      if (!parentMap.has(p)) parentMap.set(p, []);
      parentMap.get(p).push(el);
    });
    parentMap.forEach((siblings) => {
      siblings.forEach((el, i) => {
        el.style.transitionDelay = `${i * 70}ms`;
      });
    });

    els.forEach((el) => el.classList.add('paije-reveal'));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('paije-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
    );

    els.forEach((el) => io.observe(el));
  }

  // ─── 3. PRODUCT CARD TILT ────────────────────────────────────────────────────
  function initCardTilt() {
    if (window.matchMedia('(hover: none)').matches) return;

    const MAX_TILT = 6; // degrees
    const SCALE = 1.025;

    function onMove(e, card) {
      const rect = card.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;  // -0.5 → 0.5
      const y = (e.clientY - rect.top) / rect.height - 0.5;
      const rotX = -y * MAX_TILT;
      const rotY =  x * MAX_TILT;
      card.style.transform = `perspective(800px) rotateX(${rotX}deg) rotateY(${rotY}deg) scale(${SCALE})`;
    }

    function onLeave(card) {
      card.style.transform = '';
    }

    function attach(card) {
      card.addEventListener('mousemove', (e) => onMove(e, card));
      card.addEventListener('mouseleave', () => onLeave(card));
    }

    // Attach to existing cards
    document.querySelectorAll('.card-wrapper').forEach(attach);

    // Also watch for dynamically added cards (infinite scroll, filters)
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        m.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches('.card-wrapper')) attach(node);
          node.querySelectorAll && node.querySelectorAll('.card-wrapper').forEach(attach);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  // ─── 4. HORIZONTAL SCROLL SECTIONS ──────────────────────────────────────────
  function initHorizontalScroll() {
    const sections = document.querySelectorAll('[data-hscroll]');
    if (!sections.length) return;

    sections.forEach((outer) => {
      const id = outer.id.replace('hscroll-', '');
      const track = outer.querySelector('.hscroll-track');
      const fill  = outer.querySelector('.hscroll-progress-fill');
      const hint  = outer.querySelector('.hscroll-scroll-hint');
      if (!track) return;

      // Mobile: native horizontal scroll, no JS pinning
      if (window.matchMedia('(max-width: 749px)').matches) return;

      let scrollDistance = 0;

      function setup() {
        const trackW = track.scrollWidth;
        const winW   = window.innerWidth;
        scrollDistance = Math.max(0, trackW - winW);
        outer.style.height = `${scrollDistance + window.innerHeight}px`;
        onScroll();
      }

      // Run setup immediately, then again after fonts/images are loaded
      requestAnimationFrame(() => requestAnimationFrame(setup));
      window.addEventListener('load', setup, { once: true, passive: true });
      window.addEventListener('resize', setup, { passive: true });

      function onScroll() {
        const outerTop  = outer.getBoundingClientRect().top + window.scrollY;
        const rawProgress = (window.scrollY - outerTop) / scrollDistance;
        const progress = Math.max(0, Math.min(1, rawProgress));

        track.style.transform = `translateX(${-progress * scrollDistance}px)`;

        if (fill) fill.style.width = `${progress * 100}%`;
        if (hint) hint.classList.toggle('hidden', progress > 0.05);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll(); // set initial state
    });
  }

  // ─── 5. MAGNETIC BUTTONS ─────────────────────────────────────────────────────
  function initMagneticButtons() {
    if (window.matchMedia('(hover: none)').matches) return;

    const SEL = '.btn-primary, .button--primary, .btn.btn-primary, [data-magnetic], .paije-magnetic-target';
    const PULL_RADIUS = 90;  // px — how close cursor needs to be

    document.querySelectorAll(SEL).forEach((btn) => {
      btn.classList.add('paije-magnetic');

      btn.addEventListener('mousemove', (e) => {
        const r = btn.getBoundingClientRect();
        const cx = r.left + r.width  / 2;
        const cy = r.top  + r.height / 2;
        const dx = e.clientX - cx;
        const dy = e.clientY - cy;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const pull = Math.max(0, 1 - dist / PULL_RADIUS);
        btn.style.transform = `translate(${dx * pull * 0.35}px, ${dy * pull * 0.35}px) scale(${1 + pull * 0.04})`;
      });

      btn.addEventListener('mouseleave', () => {
        btn.style.transform = '';
      });
    });
  }

  // ─── 6. IMAGE REVEAL ON SCROLL ───────────────────────────────────────────────
  function initImageReveal() {
    const root = document.querySelector('main, #MainContent') || document.body;
    // Target standalone images (not inside the horizontal scroll section or card hover)
    const imgs = [];
    root.querySelectorAll(
      '.image-with-text__media img, .image-with-text-overlay__image img, ' +
      '.editorial-hero img, .hero-image img, ' +
      'figure img, .media img, .card__media img'
    ).forEach((img) => {
      if (img.closest('[data-hscroll], .card-wrapper')) return;
      if (img.closest('header, nav, .header')) return;
      imgs.push(img);
    });

    if (!imgs.length) return;

    imgs.forEach((img) => img.classList.add('paije-img-reveal'));

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('paije-img-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05, rootMargin: '0px 0px -40px 0px' }
    );

    imgs.forEach((img) => io.observe(img));
  }

  // ─── 7. PARALLAX HERO ────────────────────────────────────────────────────────
  function initParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const sections = [];

    document.querySelectorAll(
      '.slideshow__slide, .image-with-text-overlay__wrapper, .editorial-hero'
    ).forEach((section) => {
      const bg   = section.querySelector('img, .media, .slideshow__image');
      const text = section.querySelector('.slideshow__text-wrapper, .image-with-text-overlay__content, .editorial-hero__content, h1, h2');
      if (!bg && !text) return;
      if (bg)   bg.classList.add('paije-parallax-bg');
      if (text) text.classList.add('paije-parallax-text');
      sections.push({ section, bg, text });
    });

    if (!sections.length) return;

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        sections.forEach(({ section, bg, text }) => {
          const rect = section.getBoundingClientRect();
          // Skip when fully off screen
          if (rect.bottom < 0 || rect.top > window.innerHeight) { ticking = false; return; }
          // Progress: -1 (above viewport) → 0 (centered) → 1 (below viewport)
          const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
          if (bg)   bg.style.transform   = `translateY(${progress * 40}px)`;   // max ±40px
          if (text) text.style.transform = `translateY(${progress * -15}px)`;  // opposite, subtle
        });
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ─── 8. NUMBER COUNTER ANIMATION ─────────────────────────────────────────────
  function initCounters() {
    // Find text nodes that are purely a number (optionally with % + or ×)
    // Works on elements like <span>80%</span> or <strong>IGI</strong> — skips non-numeric
    const root = document.querySelector('main, #MainContent') || document.body;
    // Broad scan — leaf nodes only, so we catch stats wherever they live
    const candidates = root.querySelectorAll(
      'h1, h2, h3, h4, p, span, strong, em, li, ' +
      '[class*="stat"], [class*="number"], [class*="counter"], [class*="metric"]'
    );

    const counters = [];
    candidates.forEach((el) => {
      if (el.children.length) return; // only leaf nodes
      const text = el.textContent.trim();
      // Match: optional prefix, number (int or float), optional suffix like % + ×
      const m = text.match(/^([^0-9]*)(\d+(?:\.\d+)?)([^0-9]*)$/);
      if (!m) return;
      const target = parseFloat(m[2]);
      if (target < 2) return; // skip 0/1 — not interesting
      counters.push({ el, prefix: m[1], target, suffix: m[3], observed: false });
    });

    if (!counters.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const counter = counters.find((c) => c.el === entry.target);
          if (!counter || counter.observed) return;
          counter.observed = true;
          io.unobserve(entry.target);

          const { el, prefix, target, suffix } = counter;
          const isFloat = !Number.isInteger(target);
          const duration = 1400;
          const start = performance.now();

          function tick(now) {
            const p = Math.min(1, (now - start) / duration);
            // Ease out cubic
            const ease = 1 - Math.pow(1 - p, 3);
            const val = isFloat ? (target * ease).toFixed(1) : Math.round(target * ease);
            el.textContent = prefix + val + suffix;
            if (p < 1) requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      },
      { threshold: 0.5 }
    );

    counters.forEach(({ el }) => io.observe(el));
  }

  // ─── 9. HARD SECTION SNAP ────────────────────────────────────────────────────
  // YSL-style: when "Shop by Category" fully exits viewport going down,
  // cut instantly to "Quiet Luxury. Loud Ethics."
  function initHardSnap() {
    if (window.matchMedia('(max-width: 749px)').matches) return;

    const from = document.getElementById('shopify-section-collection_tiles_paije');
    const to   = document.getElementById('shopify-section-editorial_hero_paije');
    if (!from || !to) return;

    let locked = false;

    // IntersectionObserver fires reliably when from exits the viewport —
    // no missed ticks unlike scroll events
    const io = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (locked) return;

      // from has fully left the viewport scrolling downward
      if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
        // Only snap if to hasn't been passed yet
        const toTop = to.getBoundingClientRect().top;
        if (toTop > 10) {
          locked = true;
          // window.scrollTo(x, y) two-arg form is always instant — no smooth override
          window.scrollTo(0, to.offsetTop);
          setTimeout(() => { locked = false; }, 900);
        }
      }
    }, { threshold: 0 });

    io.observe(from);
  }

  // ─── BOOT ────────────────────────────────────────────────────────────────────
  function boot() {
    initCursorTrailer();
    initScrollAnimations();
    initCardTilt();
    initHorizontalScroll();
    initMagneticButtons();
    initImageReveal();
    initParallax();
    initCounters();
    initHardSnap();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
